import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractOutboundPhone } from "../_types/contract-outbound-phone";

@Injectable({
  providedIn: 'root',
})
export class ContractOutboundPhonesService extends Service<ContractOutboundPhone> {
  public override type = 'contractOutboundPhones';
  public override url = 'attendance/contractsOutboundPhones';
}
